import router from "../../../router";
import HeaderContent from "../header_content";
import { clearReloadEvents } from "./clear_reload_events";

export function checkChangeComponent(path: string, self: HeaderContent) {
  const currentRoutePass = router.currentRoute.path;
  if (currentRoutePass !== path) {
    clearReloadEvents(self);
  }
}
